var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUiMinusLtr = function SvgUiMinusLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M86.876 47C88.601 47 90 48.414 90 50.158c0 1.717-1.356 3.114-3.044 3.157H13.124c-1.726 0-3.124-1.413-3.124-3.157 0-1.717 1.356-3.114 3.044-3.157l.08-.001z",
    clipRule: "evenodd"
  })));
};
export default SvgUiMinusLtr;